export default Object.freeze({
    default: 'default',
    sizeLimitedLatestOnly: 'sizeLimitedLatestOnly',
    sizeLimitedFullBatch: 'sizeLimitedFullBatch'
});
